import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=6bfb2f75&scoped=true"
import script from "./withdraw.vue?vue&type=script&lang=js"
export * from "./withdraw.vue?vue&type=script&lang=js"
import style0 from "./withdraw.vue?vue&type=style&index=0&id=6bfb2f75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfb2f75",
  null
  
)

export default component.exports